import { OrganizationSuggestionsResponse } from 'store/signup/types';

const KEY = 'selectedOrganization';

export const setSelectedOrganization = (
    data: OrganizationSuggestionsResponse,
) => {
    localStorage.setItem(KEY, JSON.stringify(data));
};

export const getSelectedOrganization =
    (): OrganizationSuggestionsResponse | null => {
        const value = localStorage.getItem(KEY);

        return value
            ? (JSON.parse(value) as OrganizationSuggestionsResponse)
            : null;
    };
